import i18n from '@/utils/i18n'

export function isSiteUnderMaintenance (siteInfo) {
  if (!siteInfo) return false
  return Number(siteInfo.status_code) === 1
}

export function getSiteMaintenanceMessage (siteInfo) {
  const raw = siteInfo && siteInfo.status_msg != null
    ? String(siteInfo.status_msg).trim()
    : ''
  return raw || i18n.t('maintenance.defaultMessage')
}
